import { get } from "@repo/http-client";
import type { UserSessionInfo } from "./types";

export function fetchSessionFromApi(
  starkUrl: string,
  token: string,
): Promise<UserSessionInfo | null> {
  return get<UserSessionInfo>(`${starkUrl}/api/session`, {
    headers: { "x-ib-authorization": `Bearer ${token}` },
  });
}
